import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./StockModal.scss";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";
import OutlinedPinkButton from "../../../../components/buttons/outlinedPinkButton/OutlinedPinkButton";

export default function StockModal({
  open,
  onClose,
  onConfirm,
  title,
  children,
  isLoading = false,
}) {
  const { t } = useTranslation("stockManagement");

  return (
    <Modal show={open} onHide={onClose} centered className="stock-action-modal">
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        {!!onClose && (
          <OutlinedPinkButton onPressFunction={onClose} disabled={isLoading}>
            {isLoading ? (
              <Spinner animation="border" role="status" size="sm" />
            ) : (
              t("stock_modal_cancel")
            )}
          </OutlinedPinkButton>
        )}
        {!!onConfirm && (
          <GradientButton onPress={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <Spinner animation="border" role="status" size="sm" />
            ) : (
              t("stock_modal_confirm")
            )}
          </GradientButton>
        )}
      </Modal.Footer>
    </Modal>
  );
}
